import store from '../../store'

export default (to, from, next) => {
    store.dispatch('user/updatedView', to.name)

    next()
}
